export default __webpack_public_path__ + "static/687-310284755f54f9fd604916f024c214b6.gif";